@if (open()) {
  <app-inline-dialog class="!w-[440px] rounded-2xl max-h-[650px] overflow-y-auto">
    <mat-tab-group (selectedIndexChange)="onTabIndexChange($event)" [selectedIndex]="selectedTab()">
      <mat-tab>
        <ng-template mat-tab-label>
          <p>Activity</p>
        </ng-template>
      </mat-tab>
      <mat-tab>
        <ng-template mat-tab-label>
          <div class="flex">
            <p>Review queue</p>
          </div>
        </ng-template>
      </mat-tab>
    </mat-tab-group>
    <div class="flex flex-col mt-5">
      @for (date of notifications(); track $index) {
        <p class="mb-[14px] text-gray text-md font-bold">{{ date[0] }}</p>
        <div>
          @for (notification of date[1]; track $index) {
            <div class="notification flex items-start mb-5">
              <app-icon name="heroPhoto" class="size-10 notification-icon rounded-[7px] mr-4"></app-icon>
              <div class="flex flex-col pt-2">
                <p class="text-xs notification-title font-bold leading-[18px]">{{ notification.title }}</p>
                <p
                  [class]="
                    'text-xs leading-[18px] ' +
                    (notification.viewed || preHandled().includes(notification.id) ? 'text-gray' : 'text-blue')
                  "
                >
                  {{ notification.description }}
                </p>
                @if (
                  selectedTab() === NotificationEnum.REVIEW &&
                  !notification.metadata.handled &&
                  !preHandled().includes(notification.id)
                ) {
                  <div class="flex items-center mt-4">
                    <button
                      appButton
                      color="outlineBlue"
                      class="py-1 px-7 rounded-[7px] text-xs leading-[18px]"
                      (click)="approve(notification.metadata.commentId || '', notification.id)"
                    >
                      Approve
                    </button>
                    <button
                      appButton
                      color="white"
                      class="bg-none py-1 px-7 text-yellow text-xs leading-[18px]"
                      (click)="reject(notification.metadata.commentId || '', notification.id)"
                    >
                      <app-icon name="warning" size="small" class="size-4 button-icon mr-2"></app-icon>
                      Reject
                    </button>
                  </div>
                }
              </div>

              @if (
                selectedTab() === NotificationEnum.ACTIVITY &&
                !notification.metadata.handled &&
                notification.notificationType === 'followerRequest' &&
                !preHandled().includes(notification.id)
              ) {
                <div class="flex items-center mt-4 ml-auto">
                  <button
                    appButton
                    color="outlineBlue"
                    class="py-1 px-7 rounded-[7px] text-xs leading-[18px]"
                    (click)="share(notification.metadata.userId, notification.id)"
                  >
                    Share to
                  </button>
                  <button
                    appButton
                    color="white"
                    class="bg-none py-1 !px-1 text-yellow text-xs leading-[18px]"
                    (click)="delete(notification.metadata.userId, notification.id)"
                  >
                    <app-icon name="delete" size="small" class="size-4 button-icon mr-2"></app-icon>
                  </button>
                </div>
              }
            </div>
          }
        </div>
      } @empty {
        <p class="notification-title text-lg font-bold">List is empty</p>
        <p class="notification-title text-xs">You don’t have notifications yet</p>
      }
      <div #loadMore class="h-10"></div>
    </div>
  </app-inline-dialog>
}
